import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

const AdminCourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) return navigate("/admin");
  }, [navigate]);

  const fetchCourses = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/courses`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("adminInfo")}` },
      });
      if (!res.ok) throw new Error("Synchronization failed");
      const data = await res.json();
      setCourses(Array.isArray(data) ? data.reverse() : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses, location.search]);

  const handleDelete = async (id) => {
    if (!window.confirm("Purge this operational curriculum?")) return;
    try {
      await fetch(`${API_BASE_URL}/api/courses/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("adminInfo")}` },
      });
      fetchCourses();
    } catch (error) { console.error(error); }
  };

  const filteredCourses = courses.filter((c) =>
    (c?.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="admin-list-container"><p style={{ padding: '100px', textAlign: 'center' }}>⏳ Synchronizing Curriculum Matrix...</p></div>;

  return (
    <div className="admin-list-container">
      <div className="admin-list-content">
        <div className="page-title-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <button 
              onClick={() => navigate("/admin/dashboard")} 
              style={{ background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '10px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '1.2rem', color: '#475569', transition: 'all 0.2s' }}
              title="Back to Dashboard"
            >
              ←
            </button>
            <div>
              <h1 style={{ margin: 0 }}>Curriculum Registry</h1>
              <p style={{ margin: 0, marginTop: '4px', color: '#64748b' }}>Manage and synchronize available operational curriculums.</p>
            </div>
          </div>
          <button 
             className="btn-primary-elite" 
             onClick={() => navigate("/admin/addcourse")}
             style={{ width: 'fit-content', minWidth: '150px', background: '#6366f1', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 6px -1px rgba(99, 102, 241, 0.2)' }}
          >
            <span>➕</span> Add Courses
          </button>
        </div>

        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#6366f1' }}></div>
            Operator: Academic Dean Node
          </div>
          <div className="admin-controls">
            <div className="admin-search-wrapper">
              <span className="search-icon-fixed">🔍</span>
              <input
                type="text"
                placeholder="Search curriculum fragments..."
                className="admin-search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-status-badge" style={{ background: '#eef2ff', color: '#3730a3', fontSize: '0.75rem', fontWeight: 800 }}>
            {courses.length} ACTIVE CURRICULUMS
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Curriculum Designation</th>
                <th>Lifecycle Status</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {filteredCourses.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
                    No academic fragments detected in the current registry.
                  </td>
                </tr>
              ) : (
                filteredCourses.map((item, idx) => (
                  <tr key={item._id}>
                    <td style={{ width: '80px' }}>{idx + 1}</td>
                    <td>
                      <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1e293b' }}>{item.name}</div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>ID: {item._id.slice(-8).toUpperCase()}</div>
                    </td>
                    <td>
                      <span className="status-tag status-contacted" style={{ width: 'fit-content' }}>
                        OPERATIONAL
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="action-btn-elite btn-update" onClick={() => navigate(`/admin/editcourse/${item._id}`)}><span>✏️</span> Update</button>
                        <button className="action-btn-elite btn-delete" onClick={() => handleDelete(item._id)}><span>🗑️</span></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminCourse;
